{
    "warning": "تحذير",
    "message": "لا تدخل رمزًا لا تفهمه أو تلصقه.\nقد يسمح استخدام وحدة التحكم هذه للمعتدين بانتحال شخصيتك وسرقة معلوماتك باستخدام هجمة تسمى \"الهجوم الذاتي XSS\"."
}
